import { definePreset } from '@primeng/themes';
import Lara from '@primeng/themes/lara';

// Define a custom preset based on the Lara theme
export const NRRows = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#ffffff',
      100: '#3c7c9a',
      200: '#000',
      500: '#ced4da',
      600: '#004561',
      700: '#525252',
      800: '#000',
    },

    colorScheme: {
      light: {
        surface: {
          700: '#525252',
          100: '#3c7c9a',
        },
      },
    },
  },
  components: {
    toggleswitch: {
      extend: {
        toggleStyle: {
          borderColor: '#004561',
          offBackground: '#ffff',
          offCircleColor: '#C5D8E1',
          background: '#004561',
        },
      },
      css: ({ dt }: { dt: (key: string) => string }) => `
            
                .p-toggleswitch-slider {
                    border-color: ${dt('toggleswitch.toggleStyle.borderColor')};
                    background: ${dt('toggleswitch.toggleStyle.offBackground')};
                }
                .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover) .p-toggleswitch-slider {
                    background: ${dt('toggleswitch.toggleStyle.offBackground')};
                    border-color: ${dt('toggleswitch.toggleStyle.borderColor')};
                }
                .p-toggleswitch.p-toggleswitch-checked .p-toggleswitch-slider {
                    background: ${dt('toggleswitch.toggleStyle.background')};
                }
               
                .p-toggleswitch-handle {
                    background: ${dt('toggleswitch.toggleStyle.offCircleColor')};
                    border-color: ${dt('toggleswitch.toggleStyle.offCircleColor')};
                }
                .p-toggleswitch:not(.p-disabled):has(.p-toggleswitch-input:hover) .p-toggleswitch-handle {
                    background:  ${dt('toggleswitch.toggleStyle.offCircleColor')};
                    border-color: ${dt('toggleswitch.toggleStyle.offCircleColor')};
                }
        
            `,
    },
  },
});
// need to add toggle switch styling

// dropdown box shadow taking --p-blue-200
